<template>
  <div>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title class="text-center">Secure ID Verification</md-dialog-title>
      <md-dialog-content>
        <h6 class="text-center">You’ll need a government issued photo ID</h6>
        <div class="card">
          <ul class="md-list nav-tabs md-theme-default card_row">
            <li :class="idtype == 'DriversLicense' ? 'active' : ''" class="md-list-item">
              <button
                type="button"
                class="md-list-item-button md-list-item-container md-button-clean"
                @click="change_to_driverlicense()"
              >
                <div class="md-list-item-content md-ripple">
                  <img src="@/assets/licence.png" class="logo-size" />
                </div>
              </button>
            </li>
            <li class="md-list-item" :class="idtype == 'IdCard' ? 'active' : ''">
              <button
                type="button"
                class="md-list-item-button md-list-item-container md-button-clean"
                @click="change_to_IdCard()"
              >
                <div class="md-list-item-content md-ripple">
                  <img src="@/assets/identity.png" class="logo-size" />
                </div>
              </button>
            </li>
            <li
              class="md-list-item md-primary"
              :class="idtype == 'Passport' ? 'active' : ''"
            >
              <button
                type="button"
                class="md-list-item-button md-list-item-container md-button-clean"
                @click="change_to_passport()"
              >
                <div class="md-list-item-content md-ripple">
                  <img src="@/assets/passport.png" class="logo-size" />
                </div>
              </button>
            </li>
          </ul>
          <div
            class=""
            style="
              display: flex;
              justify-content: space-around;
              /* border: none; */
              /* outline: none; */
            "
          >
            <div class="">Driver’s licence</div>
            <div class="" style="padding: 0px 15px">Identity Card</div>
            <div class="" style="padding-left: 20px; padding-right: 20px">Passport</div>
          </div>
        </div>
        <md-dialog-actions>
          <md-progress-spinner
            v-if="showspinner"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <md-button
            class="md-raised md-primary btn-element"
            @click="go_modal6()"
            v-if="!showspinner"
            >next></md-button
          >
        </md-dialog-actions>
        <div>
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "VerifyIDType",

  data: () => ({
    showDialog: true,
    session_key: "",
    idtype: "DriversLicense",
    modal: "",
    Session: {},
    showspinner: false,
  }),

  methods: {
    go_modal6() {
      this.showspinner = true;
      this.$router.push({
        name: "PrivacyPolicy",
        params: {
          idtype: this.idtype,
          session_key: this.session_key,
          modal: this.modal,
          session: this.Session,
        },
      });
    },
    change_to_driverlicense() {
      this.idtype = "DriversLicense";
    },
    change_to_IdCard() {
      this.idtype = "IdCard";
    },
    change_to_passport() {
      this.idtype = "Passport";
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  mounted() {
    this.session_key = this.$route.params.session_key;
    this.modal = this.$route.params.modal;
    this.Session = this.$route.params.Session;
    if (this.session_key == null) {
      const _this = this;
      this.$router.push({
        name: "HandleError",
        params: {
          session: _this.Session,
          type: "notSession",
        },
      });
    }
  },
};
</script> 

<style lang="scss" scoped>
.active {
  border: 2px solid green;
  border-radius: 10px;
}
.nav-tabs {
  border: none;
}
.card {
  border: none;
}
.card_row {
  display: flex;
  flex-direction: row;
}
.logo-size {
  width: 150px;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 100px;
  padding-right: 100px;
  color: white !important;
}
.md-dialog-actions {
  justify-content: center;
  padding: 8px !important;
}
.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}
ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
li {
  display: flex;
}
.md-dialog-modal-none {
  right: unset;
  bottom: unset;
  z-index: 1;
  ::v-deep .md-dialog-container {
    box-shadow: none;
    max-width: 100%;
  }
}

.md-dialog-modal {
  z-index: 1;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>